export default __webpack_public_path__ + "static/media/fish-party.7e94d02f89796832fe751fed80abed71.jpg";